import React from 'react';
import { v4 as uuid } from 'uuid';
import Annotations, { buildUnderlines } from '@omilia/annotations';

import PropTypes from 'prop-types';
import { isObject } from 'lodash';

import { annotationType } from 'types';

import './style.scss';

// The wrapping div in this component along with it's css
// exist in UIKIt's annotation story as a styled component
// and it's called AnnotationWrapper.
// We should consider if we should export it and replace
// the wrapping div and its css with the AnnotationWrapper

const Underscores = ({ onOpenModal, value, matched: { annotations = [] } }) => (
  <div data-test="test-set-entry" role="presentation" styleName="entry">
    {buildUnderlines(value, annotations).map(underline =>
      isObject(underline) ? (
        <Annotations
          key={uuid()}
          underlines={[underline]}
          onFractionHover={onOpenModal}
        />
      ) : (
        <span key={uuid()} data-test="test-set-token-not-annotated">
          {underline}
        </span>
      ),
    )}
  </div>
);

Underscores.propTypes = {
  matched: PropTypes.shape({
    annotations: PropTypes.arrayOf(annotationType),
  }),
  value: PropTypes.string,
  onOpenModal: PropTypes.func,
};

export default Underscores;
